// extracted by mini-css-extract-plugin
module.exports = {"PageTitle":"pageTitle_PageTitle__2K0cK","HR":"pageTitle_HR__2DqI7"};